export * from './value-accessor.directive';
export * from './value-accessor.module';
